import { UUID } from "../generic/uuid";
import { OrganisationModel } from "./organisation";
import { SellerDto } from "@vini-wine/core-dtos";

export interface SellerModel extends UUID {
  // transform
  name: string;

  // available includes
  organisation?: OrganisationModel;
}

export const createSellerDtoFromAnalyticSellerModel = (
  seller: SellerModel,
): SellerDto => {
  return {
    uuid: seller.organisation ? seller.organisation.uuid : "Not found",
    name: seller.name,
  };
};
